import { render, staticRenderFns } from "./payment-thanks.vue?vue&type=template&id=4ca23608&scoped=true"
import script from "./payment-thanks.vue?vue&type=script&lang=js"
export * from "./payment-thanks.vue?vue&type=script&lang=js"
import style0 from "./payment-thanks.vue?vue&type=style&index=0&id=4ca23608&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca23608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca23608')) {
      api.createRecord('4ca23608', component.options)
    } else {
      api.reload('4ca23608', component.options)
    }
    module.hot.accept("./payment-thanks.vue?vue&type=template&id=4ca23608&scoped=true", function () {
      api.rerender('4ca23608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/payment-thanks/payment-thanks.vue"
export default component.exports